import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import HeroSection from '../components/HeroSection';
import SectorCard from '../components/SectorCard';
import { Database, Bot, Briefcase, Package } from 'lucide-react';

const HomePage = () => {
  const { country } = useParams();
  const navigate = useNavigate();

  const getCountryContent = () => {
    const content = {
      'br': {
        title: 'Transforme seu Negócio com Tecnologia Inteligente',
        subtitle: 'Soluções completas de CRM, Inteligência Artificial e Automação para o seu sucesso',
        description: 'Na Agro Urban Global, entendemos os desafios únicos do mercado brasileiro. Oferecemos soluções integradas que combinam tecnologia de ponta com suporte especializado. Desde a implementação de CRM Kommo até agentes de IA personalizados, estamos aqui para impulsionar seu crescimento.',
        sectionsTitle: 'Nossas Soluções',
        sectionsSubtitle: 'Descubra como podemos ajudar seu negócio a crescer com tecnologia de ponta',
        ctaTitle: 'Pronto para transformar seu negócio?',
        ctaSubtitle: 'Entre em contato conosco e descubra como nossas soluções podem impulsionar seu crescimento',
        ctaButton: 'Solicitar Demonstração'
      },
      'us': {
        title: 'Scale Your Business with Intelligent Technology',
        subtitle: 'Complete CRM, AI Automation, and Service Solutions for Your Success',
        description: 'At Agro Urban Global, we understand the unique challenges of the U.S. market. We offer integrated solutions that combine cutting-edge technology with specialized support. From Kommo CRM implementation to custom AI agents, we\'re here to drive your growth.',
        sectionsTitle: 'Our Solutions',
        sectionsSubtitle: 'Discover how we can help your business grow with cutting-edge technology',
        ctaTitle: 'Ready to transform your business?',
        ctaSubtitle: 'Contact us and discover how our solutions can drive your growth',
        ctaButton: 'Request Demo'
      },
      'eu': {
        title: 'Transform Your Business with Intelligent Technology',
        subtitle: 'Complete CRM, AI, and Automation Solutions for European Markets',
        description: 'At Agro Urban Global, we understand the unique challenges of European markets. We offer integrated solutions that combine cutting-edge technology with specialized support, fully compliant with EU regulations.',
        sectionsTitle: 'Our Solutions',
        sectionsSubtitle: 'Discover how we can help your business grow with cutting-edge technology',
        ctaTitle: 'Ready to transform your business?',
        ctaSubtitle: 'Contact us and discover how our solutions can drive your growth',
        ctaButton: 'Request Demo'
      },
      'uk': {
        title: 'Transform Your Business with Intelligent Technology',
        subtitle: 'Complete CRM, AI Automation, and Service Solutions for UK Market',
        description: 'At Agro Urban Global, we understand the unique challenges of the British market. We offer integrated solutions that combine cutting-edge technology with specialized support.',
        sectionsTitle: 'Our Solutions',
        sectionsSubtitle: 'Discover how we can help your business grow with cutting-edge technology',
        ctaTitle: 'Ready to transform your business?',
        ctaSubtitle: 'Contact us and discover how our solutions can drive your growth',
        ctaButton: 'Request Demo'
      }
    };
    return content[country] || content['br'];
  };

  const getSectors = () => {
    const sectorsByCountry = {
      'br': [
        {
          icon: Database,
          title: 'Gestão de Relacionamento (CRM)',
          description: 'Centralize conversas e vendas em um único lugar. Automatize processos e tome decisões baseadas em informações em tempo real.',
          link: 'crm'
        },
        {
          icon: Bot,
          title: 'Agentes de Inteligência Artificial',
          description: 'Automação inteligente com N8N. Agentes de IA que trabalham 24/7 para qualificar leads, atender clientes e otimizar seus processos.',
          link: 'ai'
        },
        {
          icon: Briefcase,
          title: 'Prestadores de Serviços Especializados',
          description: 'Aqui você encontra o profissional ideal para a sua necessidade, avaliações e vídeos te ajudam a escolher.',
          link: 'services'
        },
        {
          icon: Package,
          title: 'Produtos Inovadores',
          description: 'Catálogo completo de produtos físicos e digitais. Explore eletrônicos, saúde, alimentos, ferramentas e muito mais.',
          link: 'products'
        }
      ],
      'us': [
        {
          icon: Database,
          title: 'Customer Relationship Management (CRM)',
          description: 'Centralize conversations and sales in one place. Automate processes and make decisions based on real-time information.',
          link: 'crm'
        },
        {
          icon: Bot,
          title: 'Artificial Intelligence Agents',
          description: 'Intelligent automation with N8N. AI agents that work 24/7 to qualify leads, serve customers, and optimize your processes.',
          link: 'ai'
        },
        {
          icon: Briefcase,
          title: 'Specialized Service Providers',
          description: 'Here you find the ideal professional for your needs, reviews and videos help you choose.',
          link: 'services'
        },
        {
          icon: Package,
          title: 'Innovative Products',
          description: 'Complete catalog of physical and digital products. Explore electronics, health, food, tools, and much more.',
          link: 'products'
        }
      ],
      'eu': [
        {
          icon: Database,
          title: 'Customer Relationship Management (CRM)',
          description: 'Centralise conversations and sales in one place. Automate processes and make decisions based on real-time information.',
          link: 'crm'
        },
        {
          icon: Bot,
          title: 'Artificial Intelligence Agents',
          description: 'Intelligent automation with N8N. AI agents that work 24/7 to qualify leads, serve customers, and optimise your processes.',
          link: 'ai'
        },
        {
          icon: Briefcase,
          title: 'Specialized Service Providers',
          description: 'Here you find the ideal professional for your needs, reviews and videos help you choose.',
          link: 'services'
        },
        {
          icon: Package,
          title: 'Innovative Products',
          description: 'Complete catalogue of physical and digital products. Explore electronics, health, food, tools, and much more.',
          link: 'products'
        }
      ],
      'uk': [
        {
          icon: Database,
          title: 'Customer Relationship Management (CRM)',
          description: 'Centralise conversations and sales in one place. Automate processes and make decisions based on real-time information.',
          link: 'crm'
        },
        {
          icon: Bot,
          title: 'Artificial Intelligence Agents',
          description: 'Intelligent automation with N8N. AI agents that work 24/7 to qualify leads, serve customers, and optimise your processes.',
          link: 'ai'
        },
        {
          icon: Briefcase,
          title: 'Specialized Service Providers',
          description: 'Here you find the ideal professional for your needs, reviews and videos help you choose.',
          link: 'services'
        },
        {
          icon: Package,
          title: 'Innovative Products',
          description: 'Complete catalogue of physical and digital products. Explore electronics, health, food, tools, and much more.',
          link: 'products'
        }
      ]
    };
    return sectorsByCountry[country] || sectorsByCountry['br'];
  };

  const sectors = getSectors();

  const content = getCountryContent();

  return (
    <div className="min-h-screen bg-aug-cream">
      <Header />
      <WhatsAppButton />
      
      <div className="pt-20">
        <HeroSection
          title={content.title}
          subtitle={content.subtitle}
          description={content.description}
          ctaText="Explorar Soluções"
          ctaAction={() => {
            const element = document.getElementById('sectors');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        />

        {/* Sectors Section */}
        <section id="sectors" className="py-4xl bg-white">
          <div className="max-w-[1400px] mx-auto px-xl">
            <div className="text-center mb-3xl">
              <h2 className="text-4xl font-bold text-aug-gray-dark mb-4">
                {content.sectionsTitle}
              </h2>
              <p className="text-xl text-aug-gray-medium max-w-3xl mx-auto">
                {content.sectionsSubtitle}
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {sectors.map((sector) => (
                <SectorCard
                  key={sector.link}
                  icon={sector.icon}
                  title={sector.title}
                  description={sector.description}
                  link={sector.link}
                  country={country}
                />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-4xl bg-gradient-to-r from-aug-blue to-aug-green text-white">
          <div className="max-w-[1400px] mx-auto px-xl text-center">
            <h2 className="text-4xl font-bold mb-4">
              {content.ctaTitle}
            </h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              {content.ctaSubtitle}
            </p>
            <button
              onClick={() => navigate(`/${country}/crm`)}
              className="bg-white text-aug-blue px-8 py-4 rounded-xl font-semibold text-lg hover:bg-aug-cream transition-all duration-300 shadow-lg hover:shadow-xl"
              data-testid="home-cta-button"
            >
              {content.ctaButton}
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
